<template>
  <div
    class="modal fade"
    data-bs-backdrop="false"
    id="modalUpload"
    larger
    tabindex="-1"
    aria-labelledby="modalUpload"
    aria-hidden="true"
    style="background-color: rgba(0, 0, 0, 0.5)"
  >
    <form
      class="modal-dialog modal-dialog-centered modal-lg"
      @submit.prevent="imageUploaded"
    >
      <div class="modal-content">
        <div class="modal-header border-0 pb-0">
          <h6
            class="modal-title"
            id="modalSelectedStoreLabel"
            style="
              font-style: normal;
              font-weight: 700;
              font-size: 24px;
              color: var(--grey-medium);
            "
          >
            Gerencie o seu template
          </h6>
        </div>

        <div class="modal-body mt-0 pt-0">
          <div class="d-flex col-12 flex-wrap-reverse">
            <div class="col-md-6 col-12">
              <label
                class="btnNotMultipleImages"
                for="files"
                v-if="!this.fileLarge"
              >
                Escolher Mídia</label
              >
              <label v-else for="files" style="color: #e51717"
                >mídia maior que 200 MB</label
              >
              <dragAndDrop :select="selectFile" :size="notPermitSize" />
              <div>
                <div id="apresentar-imagem"></div>
              </div>
            </div>
            <div>
              <div class="table-responsive w-100">
                <table class="table align-middle">
                  <thead class="thead">
                    <tr style="height: 50px">
                      <th class="th-template">Responsável</th>
                      <th class="th-template">Criado em</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="td-template">{{ name }}</td>
                      <td class="td-template">{{ time }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <p class="th-template" style="margin-left: 9px">Categoria</p>
                <select
                  class="select-categoria"
                  v-model="itemSelected"
                  name=""
                  id=""
                >
                  <option
                    v-for="item in category"
                    :key="item.id"
                    class="option-categoria"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex w-100 justify-content-center align-items-center"
          style="padding: 12px"
        >
          <button
            @click="resetModal()"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="
              border-radius: 8px;
              text-align: center;
              background-color: transparent;
              color: var(--blue-medium);
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              height: 56px;
              margin: 8px;
            "
            class="border-0 w-100"
          >
            Voltar
          </button>
          <button
            @click="resetModal()"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="
              border-radius: 8px;
              text-align: center;
              background: #ffb9b9;
              color: #e51717;
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              height: 56px;
              margin: 8px;
            "
            class="border-0 w-100"
          >
            Fechar
          </button>
          <button
            type="submit"
            :disabled="fileLarge"
            style="
              border-radius: 8px;
              text-align: center;
              background: #2485ea;
              color: white;
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              height: 56px;
              margin: 8px;
            "
            :class="
              fileLarge
                ? 'border-0 w-100 notAllowed disabled'
                : 'border-0 w-100'
            "
          >
            Salvar
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment/moment";
import dragAndDrop from "./ui/DragAndDrop/dragAndDrop.vue";
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  components: { dragAndDrop },
  props: {
    name: { type: String, require: true },
    momento: { type: String, require: true },
    category: { type: Array, require: true },
    setLoading: { type: Function, require: true },
  },
  data() {
    return {
      itemSelected: 1,
      time: this.momento,
      file: null,
      notPermitSize: false,
    };
  },
  computed: {
    ...mapGetters(["fileLarge"]),
  },
  methods: {
    ...mapActions(["PostLibrary", "UploadFile", "setFile"]),
    resetModal() {
      this.time = moment().format("DD/MM/YYYY hh:mm:ss");
      this.itemSelected = 1;
    },

    selectFile(file) {
      if (file.size > 200000000) {
        this.setFile(true);
        alert(
          "Este arquivo não pode ser enviado porque excede o tamanho máximo permitido (200 MB)"
        );
      } else {
        this.setFile(false);
        this.file = file;
      }
    },

    async imageUploaded() {
      try {
        if (this.file) {
          this.setLoading(true);
          const formData = new FormData();
          formData.append("file", this.file);

          const { status, data } = await this.UploadFile(formData);

          // https://web.dev/articles/optimize-long-tasks?utm_source=devtools&hl=pt-br
          setTimeout(() => {
            if (status === 200) this.submit(data);
          }, 0);
        }
      } catch (error) {
        this.setLoading(false);
        console.error(error);
        alert("Houve um erro ao fazer upload do arquivo");
      }
    },
    async submit(url) {
      try {
        const { status } = await this.PostLibrary({
          UrlMedia: `${url}`,
          instagramLibraryCategoryId: this.itemSelected,
        });

        setTimeout(() => {
          if (status === 201) document.location.reload(true);
        }, 0);
      } catch (error) {
        alert("Houve um erro ao fazer post na biblioteca");
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>

<style>
.select-categoria {
  width: 356px;
  height: 38px;
  margin-left: 10px;
  background: #f0f2f8;
  border-radius: 4px;
  border: none;
}

.notAllowed {
  background-color: var(--blue-medium);
}
</style>
